import React, { useState } from "react";
import Styles from "./style.module.scss";
import Button from "@Atom/Button";
import ClassesDesc from "@Molecule/ClassesDesc";
import Modal from "@Atom/Modal";
import CertificateValidateModal from "./CertificateValidate";
import { useNavigate } from "react-router-dom";
import useQuery from "@Hooks/useQuery";
import NextPrevButton from "@Molecule/NextPrevButton";
import { decryptStorageData } from "@Helpers/encryptDecrypt";

export default function LearnCertificate({ data, userSheet }) {
  const [openModalValidate, setOpenModalValidate] = useState(false);
  const navigate = useNavigate();
  const query = useQuery();
  const title = query.get("t");
  const user = decryptStorageData("user", localStorage);

  return (
    <div className={Styles.container}>
      <p className={Styles.title}>Sertifikat</p>
      <div className={Styles.contentHeader}>
        <p className={Styles.contentTitle}>Unduh Sertifikat</p>
        <p className={Styles.contentDesc}>
          {userSheet.skillTest.answer.length > 0
            ? "Silahkan klik tombol download setifikat dibawah untuk mendapatkan sertifikat Anda. "
            : "Sertifikat belum tersedia, silahkan selesaikan seluruh rangkaian materi yang ada terlebih dahulu."}
        </p>
        <Button
          text={"Download Sertifikat"}
          onClick={() => setOpenModalValidate(true)}
          disabled={user?.isAssesor ? false : userSheet.score.skillTest < 1 }
        />
      </div>
      {/* <NextPrevButton
        prevText="Sebelumnya"
        // nextText="Lihat Sertifikat"
        // disabledNext={userSheet.score.preTest === -1}
        // handleNext={() =>
        //   navigate(`/classes/learn/${data._id}/certificate?t=${title}`)
        // }
        noNext
        handlePrev={() =>
          navigate(`/classes/learn/${data._id}/journal?t=${title}`)
        }
      /> */}
      <div>
        <Button
          variant="text"
          text={"Sebelumnya"}
          startIcon={"chevron-left"}
          onClick={() =>
            navigate(`/classes/learn/${data._id}/journal?t=${title}`)
          }
        />
      </div>

      <ClassesDesc data={data} />
      <Modal isOpen={openModalValidate}>
        <CertificateValidateModal
          setIsOpen={setOpenModalValidate}
          data={userSheet}
        />
      </Modal>
    </div>
  );
}
